


export const CA_API={
    //更新组织机构
    ORG_CREATE_UPDATE:"/ca/person/unitrust/org",
    //更新个人信息
    PERSON_CREATE_UPDATE:"/ca/person/unitrust/person",
    //个人：登录认证，获取token
    PERSON_AUTH_TOKEN:"/ca/person/authn/token",
    //个人：登录认证，获取个人信息
    PERSON_AUTH_INFO:"/ca/person/authn/info",

    //法人一证通：登录认证，获取token
    LEGAL_PASS_AUTH_TOKEN:"/ca/corporate/authn/token",
    //法人一证通：：登录认证，获取信息
    LEGAL_PASS_AUTH_INFO:"/ca/corporate/authn/info",
}